import { Element } from 'react-scroll'
import {
  DiagnosticCard,
  OtherDocument,
} from '~/features/common/Сars/Documents/ui'
import { Container } from '~/shared/ui/Layout'
import { KaskoDocument } from './ui/KaskoDocument'
import { ParkingCard } from './ui/ParkingCard'
import { Patent } from './ui/Patent'
import { StsDocument } from './ui/StsDocument'

export const Documents = () => {
  return (
    <>
      <Element name='sts'>
        <Container data-testid='container-sts-documents'>
          <StsDocument />
        </Container>
      </Element>

      <Element name='patent'>
        <Container data-testid='container-patent-documents'>
          <Patent />
        </Container>
      </Element>

      <Element name='kasko'>
        <Container data-testid='container-kasko-documents'>
          <KaskoDocument />
        </Container>
      </Element>

      <Element name='dc'>
        <Container data-testid='container-dc-documents'>
          <DiagnosticCard />
        </Container>
      </Element>

      <Element name='parkingCard'>
        <Container data-testid='container-parking-card-documents'>
          <ParkingCard />
        </Container>
      </Element>

      <Element name='otherDocument'>
        <Container>
          <OtherDocument />
        </Container>
      </Element>
    </>
  )
}
